// components/participantes/ExportToWord.jsx
import { Button, Tooltip, message } from "antd";
import { FaFileWord, FaDownload } from "react-icons/fa";
import { saveAs } from "file-saver";

export function ExportToWord({ participant, calls }) {
  const generateWordDocument = async () => {
    try {
      message.loading("Generando documento Word...", 1);

      const content = `
        <!DOCTYPE html>
        <html xmlns:o="urn:schemas-microsoft-com:office:office"
              xmlns:w="urn:schemas-microsoft-com:office:word"
              xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="UTF-8" />
          <title>Historial de Llamadas</title>
          <style>
            @page {
              margin: 2cm 1.5cm;
            }
            
            body {
              font-family: 'Calibri', 'Segoe UI', Arial, sans-serif;
              font-size: 11pt;
              color: #2C3E50;
              line-height: 1.4;
            }

            /* Encabezado del documento */
            .document-header {
              text-align: center;
              border-bottom: 3px solid #2C5FAA;
              padding-bottom: 15px;
              margin-bottom: 25px;
            }
            
            .document-title {
              font-size: 18pt;
              font-weight: bold;
              color: #2C5FAA;
              margin: 0 0 5px 0;
            }
            
            .document-subtitle {
              font-size: 12pt;
              color: #5D6D7E;
              margin: 0 0 15px 0;
            }
            
            .document-date {
              font-size: 10pt;
              color: #7F8C8D;
              text-align: right;
              margin-top: 20px;
            }

            /* Secciones */
            .section {
              margin-bottom: 25px;
              page-break-inside: avoid;
            }
            
            .section-title {
              font-size: 12pt;
              font-weight: bold;
              color: #2C5FAA;
              margin: 0 0 12px 0;
              padding-bottom: 6px;
              border-bottom: 2px solid #EAECEE;
            }
            
            .section-title-icon {
              display: inline-block;
              margin-right: 8px;
              vertical-align: middle;
            }

            /* Información del participante */
            .info-grid {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 8px 20px;
              margin: 15px 0;
            }
            
            .info-row {
              display: flex;
              justify-content: space-between;
              padding: 6px 0;
              border-bottom: 1px dashed #EAECEE;
            }
            
            .info-label {
              font-weight: bold;
              color: #34495E;
              min-width: 180px;
            }
            
            .info-value {
              color: #2C3E50;
              text-align: right;
              flex: 1;
            }
            
            .status-badge {
              display: inline-block;
              padding: 3px 12px;
              border-radius: 15px;
              font-size: 10pt;
              font-weight: bold;
              margin-left: 8px;
            }
            
            .status-en-proceso { background: #E8F4FD; color: #1890FF; border: 1px solid #91D5FF; }
            .status-verificado { background: #F6FFED; color: #52C41A; border: 1px solid #B7EB8F; }
            .status-no-continua { background: #FFF2F0; color: #FF4D4F; border: 1px solid #FFCCC7; }
            .status-default { background: #FAFAFA; color: #595959; border: 1px solid #D9D9D9; }

            /* Tarjetas de llamada */
            .call-card {
              border: 1px solid #E8E8E8;
              border-radius: 8px;
              margin: 20px 0;
              padding: 0;
              page-break-inside: avoid;
              background: white;
              box-shadow: 0 2px 8px rgba(0,0,0,0.06);
            }
            
            .call-header {
              background: linear-gradient(135deg, #F8FAFD 0%, #F0F5FF 100%);
              padding: 15px 20px;
              border-radius: 8px 8px 0 0;
              border-bottom: 1px solid #E8E8E8;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            
            .call-number {
              font-size: 12pt;
              font-weight: bold;
              color: #2C5FAA;
              display: flex;
              align-items: center;
              gap: 10px;
            }
            
            .call-meta {
              display: flex;
              gap: 20px;
              align-items: center;
            }
            
            .call-date {
              font-size: 11pt;
              color: #666;
              display: flex;
              align-items: center;
              gap: 6px;
            }
            
            .call-status {
              font-weight: bold;
              font-size: 11pt;
              padding: 4px 12px;
              border-radius: 20px;
            }

            /* Detalles de llamada */
            .call-details {
              padding: 20px;
            }
            
            .detail-section {
              margin-bottom: 18px;
            }
            
            .detail-title {
              font-size: 12pt;
              font-weight: bold;
              color: #5D6D7E;
              margin-bottom: 8px;
              display: flex;
              align-items: center;
              gap: 8px;
              padding-bottom: 5px;
              border-bottom: 1px solid #F0F0F0;
            }
            
            .detail-row {
              display: flex;
              margin-bottom: 6px;
              padding-left: 20px;
            }
            
            .detail-label {
              font-weight: bold;
              min-width: 200px;
              color: #666;
            }
            
            .detail-value {
              color: #333;
              flex: 1;
            }
            
            /* Motivos específicos */
            .motivos-especificos {
              margin: 12px 0 16px 20px;
              padding: 12px;
              background: #fffbfb;
              border: 1px solid #ffccc7;
              border-radius: 6px;
            }
            
            .motivos-title {
              font-weight: bold;
              color: #666;
              margin-bottom: 8px;
              display: flex;
              align-items: center;
              gap: 8px;
            }
            
            .motivos-list {
              list-style: none;
              padding-left: 0;
              margin: 0;
            }
            
            .motivo-item {
              padding: 6px 0;
              display: flex;
              align-items: flex-start;
              gap: 8px;
            }
            
            .motivo-bullet {
              color: #ff4d4f;
              font-weight: bold;
            }
            
            /* Elegibilidad */
            .elegibilidad-box {
              background: ${getElegibilidadBackground()};
              border: 1px solid ${getElegibilidadBorder()};
              border-radius: 6px;
              padding: 15px;
              margin: 15px 0;
            }
            
            .elegibilidad-header {
              display: flex;
              align-items: center;
              gap: 10px;
              margin-bottom: 12px;
              font-size: 13pt;
              font-weight: bold;
            }
            
            .elegibilidad-result {
              padding: 5px 15px;
              border-radius: 20px;
              font-weight: bold;
              font-size: 11pt;
              margin-left: 10px;
            }
            
            .result-elegible { background: #F6FFED; color: #52C41A; border: 1px solid #B7EB8F; }
            .result-no-elegible { background: #FFF2F0; color: #FF4D4F; border: 1px solid #FFCCC7; }
            
            .motivo-box {
              background: white;
              border: 1px solid #FFE7BA;
              border-radius: 4px;
              padding: 12px;
              margin-top: 10px;
            }
            
            /* Observaciones */
            .observacion-box {
              background: #F9F9F9;
              border: 1px solid #E8E8E8;
              border-radius: 6px;
              padding: 15px;
              margin: 10px 0;
            }
            
            .observacion-title {
              font-weight: bold;
              color: #722ED1;
              margin-bottom: 8px;
              display: flex;
              align-items: center;
              gap: 8px;
            }
            
            .observacion-content {
              color: #595959;
              line-height: 1.5;
              white-space: pre-line;
              padding: 10px;
              background: white;
              border-radius: 4px;
              border: 1px solid #F0F0F0;
            }

            /* Footer de llamada */
            .call-footer {
              padding: 12px 20px;
              background: #FAFAFA;
              border-top: 1px solid #E8E8E8;
              border-radius: 0 0 8px 8px;
              font-size: 9pt;
              color: #8C8C8C;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            
            .metadata-item {
              display: flex;
              align-items: center;
              gap: 6px;
            }

            /* Resumen final */
            .resumen-box {
              background: linear-gradient(135deg, #F8FBFF 0%, #E8F4FF 100%);
              border: 2px solid #2C5FAA;
              border-radius: 8px;
              padding: 20px;
              margin-top: 30px;
              page-break-before: always;
            }
            
            .resumen-title {
              font-size: 16pt;
              font-weight: bold;
              color: #2C5FAA;
              margin-bottom: 15px;
              text-align: center;
            }
            
            .resumen-grid {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 15px;
              text-align: center;
            }
            
            .resumen-item {
              padding: 15px;
              background: white;
              border-radius: 6px;
              border: 1px solid #E8E8E8;
            }
            
            .resumen-label {
              font-size: 10pt;
              color: #666;
              margin-bottom: 5px;
            }
            
            .resumen-value {
              font-size: 13pt;
              font-weight: bold;
              color: #2C5FAA;
            }
            
            /* Utilidades */
            .text-center { text-align: center; }
            .text-success { color: #52C41A; }
            .text-danger { color: #FF4D4F; }
            .text-warning { color: #FA8C16; }
            .text-info { color: #1890FF; }
            .mb-10 { margin-bottom: 10px; }
            .mt-15 { margin-top: 15px; }
            .ml-10 { margin-left: 10px; }
            .bold { font-weight: bold; }
            .italic { font-style: italic; }
          </style>
        </head>

        <body>
          ${generateDocumentContent()}
        </body>
        </html>
      `;

      const blob = new Blob([content], {
        type: "application/msword;charset=utf-8"
      });

      saveAs(
        blob,
        `Historial_Llamadas_${participant.nombres}_${participant.apellidos}_${new Date().toISOString().split('T')[0]}.doc`
      );

      message.success("Documento Word generado exitosamente");
    } catch (error) {
      console.error(error);
      message.error("Error al generar el documento");
    }
  };

  // Función para obtener colores de elegibilidad
  const getElegibilidadBackground = () => {
    const lastCall = calls?.[calls.length - 1];
    return lastCall?.esElegible ? '#F6FFED' : '#FFF2F0';
  };

  const getElegibilidadBorder = () => {
    const lastCall = calls?.[calls.length - 1];
    return lastCall?.esElegible ? '#B7EB8F' : '#FFCCC7';
  };

  // Función para renderizar motivos específicos
  const renderMotivosEspecificos = (call) => {
    const motivos = [];

    if (call.motivoOtroInfoComprobable) {
      motivos.push("Información no comprobable");
    }

    if (call.motivoOtrTresIntentos) {
      motivos.push("Tres intentos sin respuesta");
    }

    if (call.motivoOtroCual) {
      motivos.push(`¿Cuál?: ${call.motivoOtroOtro || 'No especificado'}`);
    }

    if (motivos.length === 0) return '';

    return `
      <div>
        <div class="motivos-title">
          Motivos específicos seleccionados:
        </div>
        <ul class="motivos-list">
          ${motivos.map(motivo => `
            <li class="motivo-item">
             <span style="font-weight: bold;">${motivo}</span>
            </li>
          `).join('')}
        </ul>
      </div>
    `;
  };

  const generateDocumentContent = () => {
    if (!participant || !calls?.length) return "<p>No hay datos disponibles</p>";

    const lastCall = calls[calls.length - 1];
    const totalLlamadas = calls.length;
    const estadoActual = lastCall?.estadoLlamadaNombre || 'Sin estado';

    return `
<!-- Encabezado del documento -->
<div class="document-header">
  <h1 class="document-title">📋 HISTORIAL DE LLAMADAS</h1>
  <h2 class="document-subtitle">Proceso de Validación</h2>
  <div class="document-date">
    Generado el: ${new Date().toLocaleDateString('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })}
  </div>
</div>

<!-- Sección 1: Información del participante -->
<div class="section">
  <h2 class="section-title">
    <span class="section-title-icon">👤</span> Información del Participante
  </h2>

  <div class="info-grid">
    <div class="info-row">
      <span class="info-label">Nombre completo:</span>
      <span class="info-value">${participant.nombres} ${participant.apellidos}</span>
    </div>

    <div class="info-row">
      <span class="info-label">Documento:</span>
      <span class="info-value">${participant.tipo_documento_nombre} ${participant.num_identificacion}</span>
    </div>

    <div class="info-row">
      <span class="info-label">Teléfono:</span>
      <span class="info-value">${participant.telefono || "No registrado"}</span>
    </div>

    <div class="info-row">
      <span class="info-label">Correo:</span>
      <span class="info-value">${participant.correo || "No registrado"}</span>
    </div>

    <div class="info-row">
      <span class="info-label">Ubicación registrada:</span>
      <span class="info-value">${participant.municipio}, ${participant.departamento}</span>
    </div>

    <div class="info-row">
      <span class="info-label">Estado actual:</span>
      <span class="status-badge ${getStatusClass(lastCall?.estadoLlamadaId)}">
        ${estadoActual}
      </span>
    </div>
  </div>
</div>

<!-- Sección 2: Detalle de llamadas -->
<div class="section">
  <h2 class="section-title">
    <span class="section-title-icon">📞</span> Detalle de las llamadas
  </h2>

  ${calls.map(call => `
    <div class="call-card">

      <!-- Header -->
      <div class="call-header">
        <div class="call-number">${getIntentoLabel(call.numeroIntento)}</div>
        <div class="call-meta">
          <div class="call-date">${formatFecha(call.fechaContacto)}</div>
          <div class="call-status ${getStatusClass(call.estadoLlamadaId)}">
            ${call.estadoLlamadaNombre}
          </div>
        </div>
      </div>

      <!-- Body -->
      <div class="call-details">

        <!-- Resultado del contacto -->
        <div class="detail-section">
          <div class="detail-title">Resultado del Contacto</div>

          <div class="detail-row">
            <span class="detail-label">Estado registrado:</span>
            <span class="detail-value">
              <strong>${call.estadoLlamadaNombre}</strong>
            </span>
          </div>

          ${call.subestadoLlamadaNombre ? `
            <div class="detail-row">
              <span class="detail-label">Detalle específico:</span>
              <span class="detail-value">${call.subestadoLlamadaNombre}</span>
            </div>
          ` : ''}
        </div>

        <!-- Elegibilidad -->
        ${call.esElegible !== null && call.esElegible !== undefined ? `
          <div class="detail-section">
            <div class="detail-row">
              <span class="detail-label">Evaluación de elegibilidad:</span>
              <span class="elegibilidad-result ${call.esElegible ? 'result-elegible' : 'result-no-elegible'}">
                ${call.esElegible ? 'Sí es elegible' : 'No es elegible'}
              </span>
            </div>

            ${!call.esElegible && call.motivoNoElegibleNombre ? `
              <div class="detail-row">
                <span class="detail-label">Motivo principal:</span>
                <span class="detail-value"><strong>${call.motivoNoElegibleNombre}</strong></span>
              </div>
            ` : ''}

            <!-- Motivos específicos -->
            ${!call.esElegible && (call.motivoOtroInfoComprobable || call.motivoOtrTresIntentos || call.motivoOtroCual) ?
          renderMotivosEspecificos(call) : ''}

            ${!call.esElegible && call.observacionNoElegible ? `
              <div class="detail-row">
                <span class="detail-label">Observación adicional:</span>
                <span class="detail-value"><strong>${call.observacionNoElegible}</strong></span>
              </div>
            ` : ''}

            ${!call.esElegible &&
          call.motivoNoElegibleNombre === 'Fuera del territorio priorizado' &&
          call.departamentoNombre &&
          call.municipioNombre
          ? `
              <div class="detail-row">
                <span class="detail-label">Ubicación reportada:</span>
                <span class="detail-value">
                  <strong>${call.municipioNombre}, ${call.departamentoNombre}</strong>
                </span>
              </div>
            `
          : ''
        }

          </div>
        ` : ''}

        <!-- Observación general -->
        ${call.observacionGeneral ? `
          <div class="detail-section">
            <div class="detail-title">📝 Observación general del beneficiario</div>
            <div class="observacion-content">
              ${call.observacionGeneral}
            </div>
          </div>
        ` : ''}

      </div>

      <!-- Footer -->
      <div class="call-footer">
        <div class="metadata-item">
          👤 Registrado por: <strong>${call.usuarioId || "Sistema"}</strong>
        </div>
        <div class="metadata-item">
          🕒 Fecha registro: ${formatFecha(call.createdAt)}
        </div>
      </div>

    </div>
  `).join('')}
</div>

<!-- Sección 3: Resumen ejecutivo -->
<div class="section">
  <h2 class="section-title">
    <span class="section-title-icon">📊</span> Resumen del Proceso
  </h2>

  <div class="resumen-grid">
    <div class="resumen-item">
      <div class="resumen-label">Total de llamadas</div>
      <div class="resumen-value">${totalLlamadas}</div>
    </div>

    <div class="resumen-item">
      <div class="resumen-label">Estado final</div>
      <div class="resumen-value ${getStatusClass(lastCall?.estadoLlamadaId, true)}">
        ${estadoActual}
      </div>
    </div>

    <div class="resumen-item">
      <div class="resumen-label">Última fecha</div>
      <div class="resumen-value">
        ${formatFecha(lastCall?.fechaContacto, 'short')}
      </div>
    </div>
  </div>
</div>
`;
  };

  const getIntentoLabel = (n) => {
    const labels = {
      1: "PRIMERA LLAMADA",
      2: "SEGUNDA LLAMADA",
      3: "TERCERA LLAMADA",
      4: "CUARTA LLAMADA",
      5: "QUINTA LLAMADA"
    };
    return labels[n] || `📞 LLAMADA ${n}`;
  };

  const getStatusClass = (id, textOnly = false) => {
    const classes = {
      1: textOnly ? 'text-info' : 'status-en-proceso',
      2: textOnly ? 'text-success' : 'status-verificado',
      3: textOnly ? 'text-danger' : 'status-no-continua',
      4: textOnly ? 'text-warning' : 'status-default'
    };
    return classes[id] || (textOnly ? '' : 'status-default');
  };

  const formatFecha = (fecha, format = 'full') => {
    if (!fecha) return "No registrada";

    const date = new Date(fecha);

    if (format === 'short') {
      return date.toLocaleDateString('es-ES');
    }

    return date.toLocaleString('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <Tooltip title="Exportar historial completo a Word">
      <Button
        type="primary"
        icon={<FaFileWord />}
        onClick={generateWordDocument}
        style={{
          background: "linear-gradient(135deg, #217346 0%, #28a745 100%)",
          border: "none",
          boxShadow: "0 2px 8px rgba(33, 115, 70, 0.3)",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "8px 16px",
          height: "auto"
        }}
        size="middle"
      >
        <FaDownload size={12} /> Exportar a Word
      </Button>
    </Tooltip>
  );
}